
const geoLationList = [
    {geoLocation: 104, judet: 'Bacau'},
    {geoLocation: 107, judet: 'Botosani'},
    {geoLocation: 124, judet: 'Iasi'},
    {geoLocation: 129, judet: 'Neamt'},
    {geoLocation: 135, judet: 'Suceava'},
    {geoLocation: 139, judet: 'Vaslui'},
    {geoLocation: 209, judet: 'Braila'},
    {geoLocation: 210, judet: 'Buzau'},
    {geoLocation: 214, judet: 'Constanta'},
    {geoLocation: 218, judet: 'Galati'},
    {geoLocation: 238, judet: 'Tulcea'},
    {geoLocation: 241, judet: 'Vrancea'},
    {geoLocation: 303, judet: 'Arges'},
    {geoLocation: 312, judet: 'Calarasi'},
    {geoLocation: 316, judet: 'Dambovita'},
    {geoLocation: 319, judet: 'Giurgiu'},
    {geoLocation: 323, judet: 'Ialomita'},
    {geoLocation: 331, judet: 'Prahova'},
    {geoLocation: 336, judet: 'Teleorman'},
    {geoLocation: 417, judet: 'Dolj'},
    {geoLocation: 420, judet: 'Gorj'},
    {geoLocation: 427, judet: 'Mehedinti'},
    {geoLocation: 430, judet: 'Olt'},
    {geoLocation: 440, judet: 'Valcea'},
    {geoLocation: 502, judet: 'Arad'},
    {geoLocation: 511, judet: 'Caras-Severin'},
    {geoLocation: 522, judet: 'Hunedoara'},
    {geoLocation: 537, judet: 'Timis'},
    {geoLocation: 605, judet: 'Bihor'},
    {geoLocation: 606, judet: 'Bistrita-Nasaud'},
    {geoLocation: 613, judet: 'Cluj'},
    {geoLocation: 626, judet: 'Maramures'},
    {geoLocation: 632, judet: 'Satu Mare'},
    {geoLocation: 633, judet: 'Salaj'},
    {geoLocation: 701, judet: 'Alba'},
    {geoLocation: 708, judet: 'Brasov'},
    {geoLocation: 715, judet: 'Covasna'},
    {geoLocation: 721, judet: 'Harghita'},
    {geoLocation: 728, judet: 'Mures'},
    {geoLocation: 734, judet: 'Sibiu'},
    {geoLocation: 825, judet: 'Ilfov'},
    {geoLocation: 842, judet: 'Bucuresti'}
];

export function getGeoLocation(judet) {
    const location = geoLationList.find(location => location.judet === judet);
    if(location == null)
        return ''
    else   
        return location.geoLocation
}